import React from 'react';
import { Box, Button, LinearProgress, Typography } from '@mui/material';

const SlashScreen = ({ message = '', actionLabel = '', onAction = null }) => {
  return (
    <Box
      sx={{
        alignItems: 'center',
        backgroundColor: 'background.default',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        justifyContent: 'center',
        left: 0,
        padding: 3,
        position: 'fixed',
        top: 0,
        width: '100%',
        zIndex: 2000,
      }}
    >
      <Box width={400}>
        <LinearProgress />
        {message ? (
          <Typography
            variant="body2"
            sx={{
              color: 'text.secondary',
              mt: 1.5,
              textAlign: 'center',
            }}
          >
            {message}
          </Typography>
        ) : null}
        {actionLabel && onAction ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
            <Button onClick={onAction} size="small" variant="contained">
              {actionLabel}
            </Button>
          </Box>
        ) : null}
      </Box>
    </Box>
  );
};

export default SlashScreen;
